import { useEffect, useState } from "react";
import type { Child } from "@/types";
import { getChildByIdFromList } from "@/api";

interface UseChildDetailResult {
  child: Child | null;
  isLoading: boolean;
  error: Error | null;
}

/**
 * ID bo'yicha bitta bolani real API dan qaytaradi.
 */
export function useChildDetail(
  id: number | null,
  _cachedChildren: Child[]
): UseChildDetailResult {
  const [child, setChild] = useState<Child | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (id === null) {
      setChild(null);
      setIsLoading(false);
      setError(null);
      return;
    }

    setIsLoading(true);
    setError(null);
    getChildByIdFromList(id)
      .then((res) => {
        if (!cancelled) setChild(res);
      })
      .catch((e) => {
        if (!cancelled) {
          setError(e instanceof Error ? e : new Error(String(e)));
          setChild(null);
        }
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return { child, isLoading, error };
}
